module.exports = __webpack_public_path__ + "static/media/ic_report_logo.30cdb36a.png";